import {
  IManagePrivateClassFormModel,
  IPrivateClassBackEndModel,
} from "../types";

export function parseManagePrivateClassToBackEndModel(
  frontEndModel: IManagePrivateClassFormModel,
): IPrivateClassBackEndModel {
  return {
    id: frontEndModel.id,
    teacherId: frontEndModel.teacherId,
    subjectId:
      typeof frontEndModel.subjectId === "object"
        ? (frontEndModel.subjectId as unknown as { id: number }).id
        : frontEndModel.subjectId,
    teachingLanguage:
      typeof frontEndModel.teachingLanguage === "object"
        ? (frontEndModel.teachingLanguage as unknown as { id: string }).id
        : frontEndModel.teachingLanguage,
    description: frontEndModel.description ?? "",
    extraFiles: (frontEndModel.extraFiles ?? [])
      .filter((file) => file.fileId || file.id)
      .map((file) => ({
        fileId: file.fileId || file.id,
      })),
  };
}
